import { BillingAddressType } from 'features/Billing'
import { Cargo, ICurrency } from 'features/BookingFlow'
import { TTransportMode, TTransportType } from 'features/TransportPlan'

export enum BookingRequestStateEnum {
  REQUESTED = 'requested',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
}
export const BOOKING_REQUEST_STATES = Object.keys(BookingRequestStateEnum).map((key) => BookingRequestStateEnum[key])

export const requestStatesTranslationMap = {
  [BookingRequestStateEnum.REQUESTED]: 'booking_requests-list-state-requested',
  [BookingRequestStateEnum.APPROVED]: 'booking_requests-list-state-approved',
  [BookingRequestStateEnum.REJECTED]: 'booking_requests-list-state-rejected',
  [BookingRequestStateEnum.EXPIRED]: 'booking_requests-list-state-expired',
}

interface IBookingRequestDetails {
  totalCost: ICurrency
  journey: {
    origin: string
    destination: string
  }
  mode: TTransportMode
  type: TTransportType
  expireAt: Date
  cargo: Cargo[]
}

export interface IBookingRequest {
  _id: string
  bookingTemplateId: string
  state: BookingRequestStateEnum
  sheetId: string
  optionId: string
  customerId: string
  userId: string
  details: IBookingRequestDetails
  billingAddress: BillingAddressType
  legalEntityId?: string
  bookedByFreighthub: boolean
  createdAt: Date
  updatedAt: Date
  deletedAt?: Date
  reason?: string
  reviewerId?: string
  shipmentId?: string
  customerReference?: string
}
